module.exports = __webpack_public_path__ + "static/media/Non-conforming.d2dea24b.svg";